import type { IData } from '../model/IData'
import type { IPerson } from '../model/IPerson'
import { expectDefined } from './expectDefined'
import { getParentCouple } from './getParentCouple'

export function getHalfSiblings(data: IData, personId: string) {
	const parentCouple = getParentCouple(data, personId)
	if (!parentCouple) return undefined
	const maleId = parentCouple.maleId
	const femaleId = parentCouple.femaleId
	if (maleId == null && femaleId == null) return undefined
	const couples = Object.values(data.couplesById).filter(
		(it) =>
			it.id !== parentCouple.id &&
			((maleId != null && it.maleId === maleId) ||
				(femaleId != null && it.femaleId === femaleId)),
	)
	const children: IPerson[] = []
	for (const couple of couples) {
		if (couple.childIds) {
			for (const childId of couple.childIds) {
				if (childId !== personId)
					children.push(expectDefined(data.personsById[childId]))
			}
		}
	}
	return children.toSorted((a, b) =>
		(a.birthDate ?? '').localeCompare(b.birthDate ?? ''),
	)
}
